import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Contemporary_Period_-_Climate_Change_and_Environmental_Movements.png';

function HistoryPageClimateChangeGo() {
  return (
    <QuizPage
      title="History: Climate Change and Environmental Movements"
      subTopic="Climate Change and Environmental Movements"
      backgroundImage={historyImage}
      returnPath="/History-Climate-Change"
    />
  );
}

export default HistoryPageClimateChangeGo;
